import { render, staticRenderFns } from "./OnboardingMatchingCityKnowledgePage.vue?vue&type=template&id=68e65120&scoped=true&"
import script from "./OnboardingMatchingCityKnowledgePage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingCityKnowledgePage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingCityKnowledgePage.vue?vue&type=style&index=0&id=68e65120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e65120",
  null
  
)

export default component.exports